import { useEffect, useMemo, useState } from 'react';
import { PartnersAPI } from '@/api';
import { IManager } from '@/models/admins.model';
import { TSelectOptions } from '@/ui';

export const useCategoryManagersOptions = (current?: IManager | null): TSelectOptions<string> => {
  const [managers, setManagers] = useState<IManager[]>([]);

  useEffect(() => {
    let cancelled = false;

    PartnersAPI.getCategoryManagers()
      .then((response) => {
        if (!cancelled) {
          setManagers(response.data.data ?? []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setManagers([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(() => {
    const options = managers.map((manager) => ({ label: manager.full_name, value: manager.id }));

    if (current && !options.some((option) => option.value === current.id)) {
      return [{ label: current.full_name, value: current.id }, ...options];
    }

    return options;
  }, [managers, current]);
};
